import { Pipe, PipeTransform } from '@angular/core';
import { Question } from '@features/opportunities/components/questionnaire-form/models/questionnaire';

@Pipe({
  name: 'selectedChoices',
  pure: true
})
export class SelectedChoicesPipe implements PipeTransform {
  transform(question: Question): string[] {
    if (question.answer != null && question.answer.choices != null) {
      return question.answer.choices;
    } else {
      return ['Please select'];
    }
  }
}
